import * as React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { Container } from "../../Styles/styles";
import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { API } from "../../Services/Api";
import { setgid } from "process";
import { Loader } from "../../Components/Loader";
import { Link, useParams } from "react-router-dom";
import { app_base_url } from "../../Utils/Urls";
import { useEntidade } from "../../Hooks/EntidadeHook";
import { Tipos } from "../../Model/Tipo";
import { Empresa, useUsuario } from "../../Hooks/UsuarioHook";
import EmpresaCard from "../../Components/Home/CardEmpresas";
import { GerarBoleto } from "../../Components/Empresa/GerarBoleto";
import { IssqnInformado, useIssqn } from "../../Storage/issqn";
import { Boleto } from "../../Components/Boleto";
import { RelatorioHeader } from "../../Components/Empresa/RelatorioHeader";
import LogoRelatorios from "../../Assets/analise-de-dados.png";
import LogoDinheiro from "../../Assets/dinheiro.png";
import { useEmpresa } from "../../Storage/empresa";
import { useUsuarioPrefeitura } from "../../Hooks/UsuarioPrefeituraHook";
import { ListagemIssqn } from "../../Components/Empresa/ListagemIssqn/index";

import { useSeletor } from "../../Storage/seletor";
import theme from "../../Styles/theme";
import { useUsuarioNaoEmiteNota } from "../../Hooks/UsuarioNaoEmiteNotaHook";

export function EmpresaPage() {
  const { id } = useParams();
  const { usuarioCompleto } = useUsuario();
  const { usuarioPrefeitura } = useUsuarioPrefeitura();
  const { empresa, getEmpresaFocus } = useEmpresa();
  const{usuarioNaoEmiteNota} = useUsuarioNaoEmiteNota();

  const [alteradosView, setAlteradosView] = React.useState(
    usuarioCompleto.usuario ? true : false
  );
  const [visualizarBoleto, setVisualizarBoleto] = React.useState(false);
  const { tela, setTela } = useSeletor();
  const {
    empresaFocus,
    setEmpresaFocus,
    issqnInformado,
    setPeriodoFinal,
    setPeriodoInical,
    periodoFinal,
    periodoInicial,
    setColunas,
  } = useIssqn();
  React.useEffect(() => {
    if ((id && usuarioCompleto.empresas) || (id && empresa)) {
      let filtro = [] as Empresa[];
      if (usuarioCompleto.empresas)
        filtro = usuarioCompleto.empresas.filter(
          (i) => i.CODIGO_FIRMA.toString() == id
        );

      if (empresa.length > 0)
        filtro = empresa.filter((i) => i.CODIGO_FIRMA.toString() == id);

      if (filtro.length > 0) setEmpresaFocus(filtro[0]);
    }
  }, [id, usuarioCompleto]);

  async function loadEmpresa() {
    const empresa = await getEmpresaFocus(Number(id));
    setEmpresaFocus(empresa);
  }
  React.useEffect(() => {
    if (usuarioPrefeitura.usuario) loadEmpresa();
  }, []);

  React.useEffect(() => {
    setColunas({
      PERIODO: true,
      STATUS: false,
      BASE: true,
      ISSQN: true,
      INFORMANTE: false,
      DATA_INFORMACAO: false,
      MOTIVO: true,
      VENCIMENTO: false,
      CODIGO: false,
      BASE_CALCULADA: true,
      VALOR_CALCULADO: true,
    });
  }, [tela]);



  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          width: "100%",
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          style={{ color: theme.colors.dark }}
        >
          {empresaFocus.DESCRICAO||usuarioNaoEmiteNota.DESCRICAO}
        </Typography>
      </div>

      <br />
        {visualizarBoleto? "":<RelatorioHeader empresa={empresaFocus} />}
      

      <ListagemIssqn help={setVisualizarBoleto} />

      <div style={{}}>
        <div>{/* <ListagemIssqn imprimir={true} /> */}</div>
      </div>
    </div>
  );
}
